module.exports = __webpack_public_path__ + "static/media/BodaBoda_logoFA-01.01454e98.png";